import script from "./CallTypeView.vue?vue&type=script&setup=true&lang=js"
export * from "./CallTypeView.vue?vue&type=script&setup=true&lang=js"

import "./CallTypeView.vue?vue&type=style&index=0&id=608ad9f1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608ad9f1"]])

export default __exports__